<app-address-autocomplete
  [disabled]="!isEditing"
  (addressResolved)="applyResolved($event)"
></app-address-autocomplete>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="group">
    <div class="form-group row">
      <label for="street" class="label col-sm-3 col-form-label">
        {{ "input.street.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="street"
          placeholder="{{ 'input.street.placeholder' | translate }}"
          formControlName="street"
          [status]="showInputError('street') ? 'danger' : 'basic'"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="number" class="label col-sm-3 col-form-label">
        {{ "input.houseNumber.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="number"
          placeholder="{{ 'input.houseNumber.placeholder' | translate }}"
          formControlName="number"
          [status]="showInputError('number') ? 'danger' : 'basic'"
          maxlength="13"
        />
      </div>
    </div>
  </div>

  <div class="group short-first">
    <div class="form-group row">
      <label for="zip" class="label col-sm-3 col-form-label">
        {{ "input.postalCode.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="zip"
          placeholder="{{ 'input.postalCode.placeholder' | translate }}"
          formControlName="zip"
          [status]="showInputError('zip') ? 'danger' : 'basic'"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="city" class="label col-sm-3 col-form-label">
        {{ "input.city.label" | translate }}
      </label>
      <div>
        <input
          type="text"
          nbInput
          fullWidth
          [ngClass]="{ isDisabled: !isEditing }"
          id="city"
          placeholder="{{ 'input.city.placeholder' | translate }}"
          formControlName="city"
          [status]="showInputError('city') ? 'danger' : 'basic'"
        />
      </div>
    </div>
  </div>

  <div class="form-group row">
    <label for="country_code" class="label col-sm-3 col-form-label">
      {{ "input.country.label" | translate }}
    </label>
    <div>
      <nb-select
        id="country_code"
        formControlName="country_code"
        [fullWidth]="true"
        [ngClass]="{ isDisabled: !isEditing }"
        [status]="showInputError('country_code') ? 'danger' : 'basic'"
        placeholder="{{ 'input.country.placeholder' | translate }}"
      >
        <nb-option *ngFor="let c of countries" [value]="c.code">
          {{ countryLabel(c.code) }}
        </nb-option>
      </nb-select>
    </div>
  </div>

  <div class="actions">
    <button
      *ngIf="isEditing"
      type="button"
      nbButton
      status="danger"
      outline
      (click)="isEditing = false"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      *ngIf="isEditing"
      type="submit"
      nbButton
      status="primary"
      (click)="onSubmit()"
    >
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="!isEditing"
      type="submit"
      nbButton
      outline
      status="primary"
      (click)="isEditing = true"
    >
      {{ "buttons.edit" | translate }}
    </button>
  </div>
</form>
